import React from 'react';

import {
  Grid,
  Button,
  Hidden,
  InputLabel,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const familyInfoForm = (props) => {
  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <React.Fragment>
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
          Next
          <NextIcon />
        </Button>
      </React.Fragment>
    );
  }

  let blockquote = null;

  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
        Write about your family.
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {blockquote}
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="father_name"
            config={props.inputs.father_name}
            changed={event => props.inputChangedHandler(event, 'father_name')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="mother_name"
            config={props.inputs.mother_name}
            changed={event => props.inputChangedHandler(event, 'mother_name')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="father_occupation"
            config={props.inputs.father_occupation}
            changed={event => props.inputChangedHandler(event, 'father_occupation')}
            loadOptions={() => asyncSelectData.getOptionConstants('father_occupation')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="mother_occupation"
            config={props.inputs.mother_occupation}
            changed={event => props.inputChangedHandler(event, 'mother_occupation')}
            loadOptions={() => asyncSelectData.getOptionConstants('mother_occupation')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="native_place"
            config={props.inputs.native_place}
            changed={event => props.inputChangedHandler(event, 'native_place')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="mosal"
            config={props.inputs.mosal}
            changed={event => props.inputChangedHandler(event, 'mosal')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="nanaji"
            config={props.inputs.nanaji}
            changed={event => props.inputChangedHandler(event, 'nanaji')}
          />
        </Grid>
        <Hidden xsDown>
          <Grid item md={6} xs={6} sm={6}>&nbsp;</Grid>
        </Hidden>
        <Grid item md={6} xs={12} sm={6}>
          <InputLabel className={classes.formLabel}>Brothers</InputLabel>
          <Grid container spacing={24}>
            <Grid item md={6} sm={6} xs={6}>
              <InputField
                id="brother_count"
                config={props.inputs.brother_count}
                changed={event => props.inputChangedHandler(event, 'brother_count')}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <InputField
                id="brother_married"
                config={props.inputs.brother_married}
                changed={event => props.inputChangedHandler(event, 'brother_married')}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputLabel className={classes.formLabel}>Sisters</InputLabel>
          <Grid container spacing={24}>
            <Grid item md={6} sm={6} xs={6}>
              <InputField
                id="sister_count"
                config={props.inputs.sister_count}
                changed={event => props.inputChangedHandler(event, 'sister_count')}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <InputField
                id="sister_married"
                config={props.inputs.sister_married}
                changed={event => props.inputChangedHandler(event, 'sister_married')}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default familyInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/FamilyInfoForm.js